const Accordion = {
  init() {
    const $items = $('.js-accordion-item .js-accordion-title');
    if ( $items.length > 0 ) {
      console.log('init accordion');
      $items.on('click', (event) => this.handleClick(event.delegateTarget) );
    }
  },
  handleClick(el) {
    const $$ = $(el).parent();
    if ( $$.hasClass('is-open') ) {
      this.close($$);
    } else {
      this.open($$);
    }
  },
  open($$) {
    $$.addClass('is-open');
    $$.find('.js-accordion-item-detail').slideDown();
  },
  close($$) {
    $$.removeClass('is-open');
    $$.find('.js-accordion-item-detail').slideUp();
  }
};
$(Accordion.init.bind(Accordion));
